
    import Vue from 'vue';
    import { RouterLink } from 'vue-router'
    import FilePathService from '@/apps/shared/services/filePath-service';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import localityService from '@/apps/shared/services/locality-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    export default Vue.extend({
        components: {
            RouterLink,
            XBreadcrumb,
            WhatsApp,
        },
        busEvents: {
        },
        name: 'healthMaxPolicyOwner-view',
        data() {
            return {
                capital: null,
                BreadcrumbText: "Datos de la persona que contrata",
                additionalCovers: [],
                coversDetail: [],
                effectDate: null,
                primerCuota: 0,
                DataPlan: {
                    planDescription: ''
                },
                expirationDate: null,
                activeStep: 0,
                breadcrumItems: [
                    { text: 'Inicio', path: '/salud-segura-max' },
                    { text: 'Datos de la Persona que Contrata', path: '/salud-segura-max/contratante' }
                ],
                docTypeSelected: null,
                personToCoverDocTypeSelected: null,
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                maxSelections: 2,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                numDoc: null,
                personToCoverNumDoc: null,
                isNotSelectedDocumentType: true,
                isPersonToCoverNotSelectedDocumentType: true,
                searchButtonDisable: true,
                searchButtonPersonToCoverDisable: true,
                payButtonDisable: true,
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                telephone: '',
                streetName: null,
                birthday: null,
                isBirthdayCorrect: false,
                personToCover: {
                    activeFormPersonNotExist: false,
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    isBirthdayCorrect: true,
                    firstName: "",
                    lastName: "",
                    numDoc: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: "",
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    isNotSelectedDocumentType: false,
                    address: null,
                    isEqualToPolicyOwner: false,
                },
                messageErrorAge: null,
                age: '0',
                stringDate: '',
                piso: null,
                numDom: null,
                numDept: null,
                areaCode: '',
                email: '',
                selectedLocality: null,
                cityName: null,
                cityId2: null,
                localityId: null,
                zipCode: null,
                Procesoautomatico: false,
                MaximDigitSuperatedDni: false,
                isPersonExist: false,
                activeForm: false,
                minimumInputLength: 4,
                accept: true,
                coberturasAmparo: [],
                gender: null,
                officeId: null,
                city: null,
                address: null,
                selectedIvaCondition: null,
                province: null,
                genderId: null,
                firstName: "",
                lastName: "",
                activeFormPersonNotExist: false,
                hasLocality: false,
                localityIsSelected: true,
                disable: true,
                validatePhone: false,
                messageErrorAreaCode: null,
                messageErrorPhone: null,
                messageError: null,
                messageErrorDigits: null,
                validDigits: null,
                numDocChange: null,
                numDocExisting: null,
                numDocPersonToCoverChange: null,
                numDocPersonToCoverExisting: null,
                currentStep: 1,
                totalStep: 2,
                isAssuredTitular: true,
                currentGroup: null,
                isLastStep: true,
                isValidPersonToCoverData: false,
                isPerson: false,
                isPersonPersonToCover: false,
                isJuridico: false,
                isJuridicoPersonToCover: false,
                multiplePeopleWithSameIdentifier: [],
                isSearchPersonToCover: false,
                personWithSameIdentifierSelected: null,
                isPeopleWithSameIdentifierModalOpen: false,
                premiumWithoutDiscount: null,
                thereIsDiscount: false,
                leadId: null
            };
        },
        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true;
                let message = "";
                if (this.docTypeSelected.id == 'D' && val.length != 7 && val.length != 8) {
                    this.searchButtonDisable = true;
                    if (val.length > 0) {
                        valid = false
                        message = "La cantidad de dígitos es incorrecta."
                    }
                    else {
                        valid = false
                        message = "Este campo es obligatorio."
                    }
                } else if (this.docTypeSelected.id == 'D' && (val.length == 7 || val.length == 8)) {
                    if (this.numDocExisting != val) {
                        this.numDocChange = true;
                        this.numDocExisting = val;
                    }

                    this.searchButtonDisable = false;
                }
                else {
                    this.searchButtonDisable = false;
                }
                if (this.numDoc === "" || this.numDoc === null) {
                    this.searchButtonDisable = true;
                };
                return {
                    valid,
                    message
                }
            };
            window.globalThis.validatePersonToCoverNumDoc = (val) => {
                let valid = true
                let message = ""
                if (this.personToCoverDocTypeSelected.id == 'D' && val.length != 7 && val.length != 8) {
                    this.searchButtonPersonToCoverDisable = true;
                    if (val.length > 0) {
                        valid = false
                        message = "La cantidad de dígitos es incorrecta."
                    }
                    else {
                        valid = false
                        message = "Este campo es obligatorio."
                    }
                } else if (this.personToCoverDocTypeSelected.id == 'D' && (val.length == 7 || val.length == 8)) {
                    if (this.numDocPersonToCoverExisting != val) {
                        this.numDocPersonToCoverChange = true;
                        this.numDocPersonToCoverExisting = val;
                    }
                    this.searchButtonPersonToCoverDisable = false;
                }
                else {
                    this.searchButtonPersonToCoverDisable = false;
                }
                return {
                    valid,
                    message
                }
            };
        },
        methods: {
            openSelectMultiplePeopleModal: function (peopleList) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                // Inicializar el array multiplePeopleWithSameIdentifier
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => {
                    let newPerson = {
                        id: idCounter++,
                        birthday: person.birthday,
                        firstName: person.firstName,
                        lastName: person.lastName,
                        email: person.email,
                        selectedIvaCondition: person.ivaConditionFiscalId,
                        areaCode: person.phoneAreaCode,
                        telephone: person.phoneNumber,
                        hasLocality: person.hasLocality,
                        address: null,
                        document: null
                    };
                    if (person.address != null && person.address != undefined) {
                        newPerson.address = {
                            cityId: person.address.cityId,
                            streetNumber: person.address.streetNumber,
                            streetName: person.address.streetName,
                            zipCode: person.address.zipCode,
                            floor: person.address.floor,
                            department: person.address.department
                        };
                    };
                    if (person.document != null && person.document != undefined) {
                        newPerson.document = person.document;
                    };
                    return newPerson;
                });
                this.$refs.selectMultiplePeopleModal.open();
            },
            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
            },
            closeSelectMultiplePeopleModal: function () {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                this.$refs.selectMultiplePeopleModal.close();
            },

            onSelectedClient(id) {
                this.personWithSameIdentifierSelected = id;
                let selectedPerson = this.multiplePeopleWithSameIdentifier.find(item => this.personWithSameIdentifierSelected == item.id);
                if (this.isSearchPersonToCover) {
                    this.setPersonToCover(selectedPerson);
                    this.personToCover.isEqualToPolicyOwner = (this.personToCoverNumDoc === this.numDoc
                        && this.personToCoverDocTypeSelected.id === this.docTypeSelected.id
                        || (this.personToCoverNumDoc === this.numDoc
                            && selectedPerson.firstName === this.firstName && selectedPerson.lastName === this.lastName));
                    //Si se ingresó dni de la persona a cubrir se buscan los datos de la misma
                    if (this.personToCoverNumDoc != "" && !this.personToCover.isEqualToPolicyOwner) {
                        this.ageCalculate(true);
                        this.validatePersonToCoverData();
                        if (this.isValidPersonToCoverData) {
                            this.finallySetPersonToCover();
                        }
                        else if (!this.isAssuredTitular) {
                            this.$refs.personToCoverModal.open();
                        }
                    }
                    else {
                        //Se anulan los datos de la persona a cubrir
                        sessionStorage.setItem("personToCover", JSON.stringify(null));
                        if (!this.isAssuredTitular) {
                            this.$refs.personToCoverModal.open();
                        }
                    }
                } else {
                    searchPersonService.SetPerson(selectedPerson.lastName, selectedPerson.firstName)
                        .then(response => {
                            this.setPolicyOwner(selectedPerson);
                            this.finallySetPolicyOwner();
                        })
                        .catch(error => {
                            this.searchPersonData();
                        });
                }
                setTimeout(() => { this.closeSelectMultiplePeopleModal(); }, 300);
            },

            setPolicyOwner(policyOwner) {
                let dataClientTabOne = JSON.parse(sessionStorage.getItem("DataTabHome"));
                this.activeFormPersonNotExist = false;
                this.isPersonExist = true;
                this.activeForm = true;
                this.birthday = policyOwner.birthday;
                this.firstName = policyOwner.firstName;
                this.lastName = policyOwner.lastName;
                this.email = dataClientTabOne.email;
                this.docTypeSelected = this.documentTypeList.find(p => p.id.trim() == policyOwner.document.identificationTypeCode);
                this.selectedIvaCondition = policyOwner.ivaConditionFiscalId != null && policyOwner.ivaConditionFiscalId != 0 && policyOwner.ivaConditionFiscalId != undefined ? (this.ivaConditionList.find(o => o.id == policyOwner.ivaConditionFiscalId || o.name == policyOwner.ivaConditionFiscalId)) : (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"))
                this.areaCode = dataClientTabOne.areaCode.replace(/^0+/, '');
                this.telephone = dataClientTabOne.telephone.replace(/^15+/, '');
                this.hasLocality = policyOwner.hasLocality;
                if (policyOwner.address != null && policyOwner.address != undefined) {
                    this.address = {
                        cityId: policyOwner.address.cityId,
                        streetNumber: policyOwner.address.streetNumber,
                        streetName: policyOwner.address.streetName,
                        zipCode: policyOwner.address.zipCode,
                        floor: policyOwner.address.floor,
                        department: policyOwner.address.department
                    };
                }

                sessionStorage.setItem("clientData", JSON.stringify({
                    documentType: policyOwner.document.identificationTypeCode,
                    documentNumber: policyOwner.document.identificationNumber,
                    firstName: this.firstName,
                    lastName:  this.lastName,
                    localidad: policyOwner.localityName,
                    email: this.email,
                    telephone: this.telephone,
                    areaCode: this.areaCode

                }));

                window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'cotizador-salud-dni' });
            },
            finallySetPolicyOwner() {
                this.savePolicyOwner();
            },
            setPersonToCover(personToCover) {
                let dataClientTabOne = JSON.parse(sessionStorage.getItem("DataTabHome"));
                this.personToCover.activeFormPersonNotExist = false;
                this.personToCover.isPersonExist = true;
                this.personToCover.activeForm = true;
                this.personToCover.numDoc = this.personToCoverNumDoc;
                this.personToCover.docTypeSelected = this.documentTypeList.find(p => p.id.trim() == personToCover.document.identificationTypeCode);
                this.personToCover.birthday = personToCover.birthday;
                this.personToCover.firstName = personToCover.firstName;
                this.personToCover.lastName = personToCover.lastName;
                this.personToCover.email = personToCover?.email ?? dataClientTabOne.email;
                this.personToCover.selectedIvaCondition = personToCover.ivaConditionFiscalId != null && personToCover.ivaConditionFiscalId != 0 && personToCover.ivaConditionFiscalId != undefined ? (this.ivaConditionList.find(o => o.id == personToCover.ivaConditionFiscalId || o.name == personToCover.ivaConditionFiscalId)) : (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"))
                this.personToCover.areaCode = personToCover?.phoneAreaCode?.replace(/^0+/, '') ?? dataClientTabOne.areaCode;
                this.personToCover.telephone = personToCover?.phoneNumber?.replace(/^15+/, '') ?? dataClientTabOne.telephone;
                this.personToCover.hasLocality = personToCover.hasLocality;
                if (personToCover.address != null && personToCover.address != undefined) {
                    this.personToCover.address = {
                        cityId: personToCover.address.cityId,
                        streetNumber: personToCover.address.streetNumber,
                        streetName: personToCover.address.streetName,
                        zipCode: personToCover.address.zipCode,
                        floor: personToCover.address.floor,
                        department: personToCover.address.department
                    };
                }
                sessionStorage.setItem("clientData", JSON.stringify({
                    documentType: this.personToCover.docTypeSelected,
                    documentNumber: this.personToCover.numDoc,
                    firstName: this.personToCover.firstName,
                    lastName: this.personToCover.lastName,
                }));
            },
            finallySetPersonToCover() {
                if (this.personToCover != null && this.personToCover.isPersonExist && this.personToCover.isBirthdayCorrect) {
                    this.$refs.personToCoverModal.close();
                    this.savePolicyOwner();
                    this.goToPersonToCoverView();
                }
            },
            goToPersonToCoverView() {
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.personToCover.email, location.href, this.personToCover.areaCode, this.personToCover.telephone, 321, false, "3", null, this.personToCover.lastName, this.personToCover.firstName);
                this.savePersonToCover();
                let pricingId = parseInt(sessionStorage.getItem("selectedPricingId"));
                window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'cotizador-salud-datos-contratante' });
                window.location.href = '../salud-segura-max/datosAsegurado' + "?cotizacion=" + pricingId;
            },
            validatePersonToCoverData() {
                if (this.personToCover.firstName != null && this.personToCover.firstName != "" &&
                    this.personToCover.lastName != null && this.personToCover.lastName != "" &&
                    this.personToCover.birthday != null &&
                    this.personToCover.isBirthdayCorrect
                ) {
                    this.isValidPersonToCoverData = true;
                } else {
                    this.isValidPersonToCoverData = false;
                };
            },
            resetPersonToCoverData() {
                this.personToCover = {
                    activeFormPersonNotExist: false,
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    isBirthdayCorrect: true,
                    firstName: "",
                    lastName: "",
                    numDoc: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: "",
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    isNotSelectedDocumentType: false,
                    address: null,
                    isEqualToPolicyOwner: false,
                };
            },
            openCancelModal: function () {
                this.$refs.cancelModal.open();
            },
            closeCancelModal: function () {
                this.resetPersonToCoverData();
                this.$refs.cancelModal.close();
            },
            closePersonToCoverModal() {
                this.personToCover.activeFormPersonNotExist = false;
                this.personToCover.firstName = "";
                this.personToCover.lastName = "";
                this.$refs.personToCoverModal.close();
            },
            searchPersonToCover() {
                this.getPersonByDocumentAndType(true);
            },
            anterior() {
                this.savePolicyOwner();
                sessionStorage.removeItem("pressBack");
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'healthMaxPlansSelection-view',
                })
            },
            pagar() {
                this.savePolicyOwner();
                sessionStorage.removeItem("pressBack");
                sessionStorage.setItem("pressBack", "false");
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, this.areaCode, this.telephone, 321, false, "3", null, this.lastName, this.firstName);
                let pricingId = parseInt(sessionStorage.getItem("selectedPricingId"));
                window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'cotizador-salud-datos-contratante' });
                window.location.href = '../salud-segura-max/resumen';
            },
            siguiente() {
                sessionStorage.removeItem("pressBack");
                sessionStorage.setItem("pressBack", "false");
                this.savePolicyOwner();
                let isFamilyPlan = parseInt(sessionStorage.getItem("peopleToCover")) > 1;
                if (!this.isAssuredTitular) {
                    this.$refs.personToCoverModal.open();
                } else if (isFamilyPlan) {
                    let pricingId = parseInt(sessionStorage.getItem("selectedPricingId"));
                    window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'cotizador-salud-datos-contratante' });
                    window.location.href = '../salud-segura-max/datosFamiliar' + "?cotizacion=" + pricingId;
                }
            },
            searchPersonData() {
                this.streetName = null;
                this.piso = null;
                this.numDom = null;
                this.numDept = null;
                this.selectedLocality = null;
                this.getPersonByDocumentAndType(false);
            },
            changeTitleAndIcon() {
                // Lógica para determinar el nuevo título
                const newTitle = 'Salud Segura Max';
                // Emite eventos para actualizar el título
                this.$emit('updateTitle', newTitle);
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear().toString();
                return `${day}/${month}/${year}`;
            },
            showFileError(errorMessage) {
                NF.Notification.show({
                    type: NF.Notification.Type.ERROR,
                    title: 'Error',
                    content: errorMessage,
                    position: NF.Notification.Positions.TOP_RIGHT,
                    clickClose: true,
                    autoHideDelay: 0
                })
            },
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "salud-segura-max";
                    });
            },
            getDocumentType() {
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element =>
                            ({ ...element, id: element["id"], text: element["name"] }))
                        if (!this.docTypeSelected) {
                            this.docTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                        }
                        this.personToCoverDocTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                    }
                })
            },
            getIvaConditions() {
                ivaConditionService.getIvaConditionsList().then(response => {
                    if (response.length != 0) {
                        this.ivaConditionList = response.map(element => ({ ...element, id: element["id"].toString(), text: element["name"] }))
                    }
                })
            },
            savePolicyOwner() {
                let policyOwner = {
                    activeFormPersonNotExist: this.activeFormPersonNotExist,
                    isPersonExist: this.isPersonExist,
                    activeForm: this.activeForm,
                    birthday: this.birthday,
                    firstName: this.firstName,
                    lastName: this.lastName,
                    docTypeSelected: this.docTypeSelected,
                    email: this.email,
                    selectedIvaCondition: this.selectedIvaCondition,
                    areaCode: this.areaCode,
                    telephone: this.telephone,
                    hasLocality: this.hasLocality,
                    MaximDigitSuperatedDni: this.MaximDigitSuperatedDni,
                    age: this.age,
                    numDoc: this.numDoc,
                    isBirthdayCorrect: this.isBirthdayCorrect,
                    selectedLocality: this.selectedLocality,
                    isNotSelectedDocumentType: this.isNotSelectedDocumentType,
                    address: this.address,
                    isLastStep: this.isLastStep,
                };
                sessionStorage.setItem("policyOwner", JSON.stringify(policyOwner));
            },
            savePersonToCover() {
                sessionStorage.setItem("personToCover", JSON.stringify(this.personToCover));
            },
            getPersonByDocumentAndType: function (isSearchPersonToCover = false) {
                this.isSearchPersonToCover = isSearchPersonToCover;
                this.numDocChange = false;
                this.activeFormPersonNotExist = false;
                this.hasLocality = false;
                let dataClientTabOne = JSON.parse(sessionStorage.getItem("DataTabHome"));
                NF.UI.Page.blockCustom({ message: 'Cargando datos...' });
                //Si viene desde el modal de persona a cubrir
                if (isSearchPersonToCover) {
                    this.personToCover = {
                        activeFormPersonNotExist: false,
                        isPersonExist: false,
                        activeForm: false,
                        birthday: null,
                        isBirthdayCorrect: true,
                        firstName: "",
                        lastName: "",
                        numDoc: "",
                        docTypeSelected: null,
                        email: "",
                        selectedIvaCondition: null,
                        areaCode: "",
                        telephone: "",
                        hasLocality: false,
                        MaximDigitSuperatedDni: false,
                        age: "",
                        selectedLocality: null,
                        isNotSelectedDocumentType: false,
                        address: null,
                        isEqualToPolicyOwner: false,
                    };
                    this.personToCover.isEqualToPolicyOwner = (this.personToCoverNumDoc === this.numDoc && this.personToCoverDocTypeSelected.id === this.docTypeSelected.id);
                    //Si se ingresó dni de la persona a cubrir se buscan los datos de la misma
                    if (this.personToCoverNumDoc != "" && !this.personToCover.isEqualToPolicyOwner) {
                        let Dni = this.personToCoverNumDoc == null ? 0 : this.personToCoverNumDoc;
                        let DocTypeSeleccionado = this.personToCoverDocTypeSelected.name.trim();
                        searchPersonService.GetSearchPersonData(Dni, this.personToCoverDocTypeSelected.id, false)
                            .then(response => {
                                if (response.searchPersonResult.length > 1) {
                                    this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                    this.closePersonToCoverModal();
                                    return;
                                }
                                let result = response.searchPersonResult[0];
                                if (result != undefined && (result && result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                    this.setPersonToCover(result);
                                }
                                else {
                                    this.personToCover.isPersonExist = false;
                                    this.personToCover.firstName = "";
                                    this.personToCover.email = dataClientTabOne?.email ?? "";
                                    this.personToCover.areaCode = dataClientTabOne?.areaCode ?? "";
                                    this.personToCover.telephone = dataClientTabOne?.telephone ?? "";
                                    this.personToCover.age = "";
                                    this.personToCover.numDoc = this.personToCoverNumDoc;
                                    this.personToCover.docTypeSelected = this.personToCoverDocTypeSelected;
                                    this.personToCover.selectedIvaCondition = (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"));
                                    this.personToCover.birthday = null;
                                    this.personToCover.lastName = "";
                                    this.personToCover.activeFormPersonNotExist = true;
                                    this.personToCover.selectedLocality = null;
                                }
                                if (Dni.toString().length > 0 && Dni.toString().length < 9) {
                                    this.personToCover.MaximDigitSuperatedDni = false;
                                }
                                else if (DocTypeSeleccionado == "DNI") {
                                    this.personToCover.MaximDigitSuperatedDni = true;
                                    this.personToCover.firstName = "";
                                    this.personToCover.lastName = "";
                                    this.personToCover.birthday = null;
                                    this.personToCover.isPersonExist = true;
                                    this.personToCover.isNotSelectedDocumentType = false
                                    this.personToCover.age = "";
                                    this.personToCover.activeFormPersonNotExist = true;
                                }
                                else {
                                    this.personToCover.MaximDigitSuperatedDni = true;
                                }
                            })
                            .then(() => {
                                NF.UI.Page.unblock();
                            }).catch(() => {
                            })
                            .finally(() => {
                                if (!this.isPeopleWithSameIdentifierModalOpen) {
                                    this.finallySetPersonToCover();
                                };
                            });
                    }
                    else {
                        //Se anulan los datos de la persona a cubrir
                        sessionStorage.setItem("personToCover", JSON.stringify(null));
                        NF.UI.Page.unblock();
                    }
                } else if (this.numDoc != "") { //Si viene desde la búsqueda principal de la página, que sería la del tomador
                    let Dni = this.numDoc == null ? 0 : this.numDoc;
                    let DocTypeSeleccionado = this.docTypeSelected.name.trim();
                    searchPersonService.GetSearchPersonData(this.numDoc, this.docTypeSelected.id)
                        .then(response => {
                            if (response.searchPersonResult.length > 1) {
                                this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                return;
                            }
                            let result = response.searchPersonResult[0];
                            if (result != undefined && (result && result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                this.setPolicyOwner(result);
                            }
                            else {
                                this.activeForm = true;
                                this.isPersonExist = false;
                                this.firstName = "";
                                this.email = dataClientTabOne?.email ?? "";
                                this.areaCode = dataClientTabOne?.areaCode ?? "";
                                this.telephone = dataClientTabOne?.telephone ?? "";
                                this.age = "";
                                this.selectedIvaCondition = (this.ivaConditionList.find(o => o.id == 4 || o.name == "Consumidor Final"));
                                this.birthday = null;
                                this.lastName = "";
                                this.activeFormPersonNotExist = true;
                                this.selectedLocality = null;
                                window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'errorUsuario', 'paso': 'cotizador-salud-dni' });
                            }
                            if (Dni.toString().length > 0 && Dni.toString().length < 9) {
                                this.MaximDigitSuperatedDni = false;
                            }
                            else if (DocTypeSeleccionado == "DNI") {
                                this.MaximDigitSuperatedDni = true;
                                this.firstName = "";
                                this.lastName = "";
                                this.birthday = null;
                                this.isPersonExist = true;
                                this.isNotSelectedDocumentType = false
                                this.age = "";
                            }
                            else {
                                this.MaximDigitSuperatedDni = true;
                            }
                        })
                        .then(() => {
                            NF.UI.Page.unblock();
                        })
                        .catch(() => {
                            window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'errorServidor', 'paso': 'cotizador-salud-dni' });
                        })
                        .finally(() => {
                            this.finallySetPolicyOwner();
                        });
                }
                else {
                    this.activeForm = false;
                    this.activeFormPersonNotExist = false;
                    this.birthday = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.selectedIvaCondition = null;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },
            CleanPersonDataForm: function () {
                if (this.numDoc == "") {
                    NF.UI.Page.blockCustom({ message: 'Limpiando datos..' });
                    this.activeForm = false;
                    this.activeFormPersonNotExist = false;
                    this.birthday = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = false;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },
            isSelectedDocumentType: function () {
                this.isNotSelectedDocumentType = false;
                this.docTypeSelected != null ? this.docTypeSelected.name.trim() != "CUIT" ? (this.isPerson = true, this.isJuridico = false) : (this.isJuridico = true, this.isPerson = false) : null
                this.numDoc = "";
                this.birthday = null;
                this.piso = "";
                this.numDept = "";
                this.numDom = "";
                this.streetName = null;
                this.searchButtonDisable = true;
                this.hasLocality = false;
            },
            isPersonToCoverSelectedDocumentType: function () {
                this.isPersonToCoverNotSelectedDocumentType = false;
                this.personToCoverDocTypeSelected != null ? this.personToCoverDocTypeSelected.name.trim() != "CUIT" ? (this.isPersonPersonToCover = true, this.isJuridicoPersonToCover = false) : (this.isJuridicoPersonToCover = true, this.isPersonPersonToCover = false) : null
                this.personToCoverNumDoc = "";
                this.resetPersonToCoverData();
            },

            ageCalculate: function (isPersonToCover = false) {
                if (!isPersonToCover) {
                    this.messageErrorAge = "";
                    this.isBirthdayCorrect = false;
                    let birthDate = null;
                    let age = null;
                    let m = null;
                    if (this.birthday != null && this.birthday != "") {
                        let today = new Date();
                        if (this.birthday.toString().length > 11) {
                            birthDate = new Date(this.birthday);
                            age = today.getFullYear() - birthDate.getFullYear();
                            m = today.getMonth() - birthDate.getMonth();
                            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                                age--;
                            }
                            this.age = age;
                            if (this.age < 18) {
                                this.messageErrorAge = "La persona debe ser mayor de 18 años";
                            }
                            if (this.age > 64) {
                                this.messageErrorAge = "La persona debe tener menos de 65 años";
                            }
                            if (this.messageErrorAge == "") {
                                this.isBirthdayCorrect = true;
                            }
                        }
                        else {
                            let dateFormated = this.birthday.split('/')[1] + "/" + this.birthday.split('/')[0] + "/" + this.birthday.split('/')[2];
                            birthDate = new Date(dateFormated);
                            age = today.getFullYear() - birthDate.getFullYear();
                            m = today.getMonth() - birthDate.getMonth();
                            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                                age--;
                            }
                            this.age = age;
                            if (this.age < 18) {
                                this.messageErrorAge = "La persona debe ser mayor de 18 años";
                            }
                            if (this.age > 64) {
                                this.messageErrorAge = "La persona debe tener menos de 65 años";
                            }
                            if (this.messageErrorAge == "") {
                                this.isBirthdayCorrect = true;
                            }
                        }
                    }
                    else {
                        this.age = 0;
                    }
                } else {
                    this.personToCoverMessageErrorAge = "";
                    this.personToCover.isBirthdayCorrect = false;
                    let birthDate = null;
                    let age = null;
                    let m = null;
                    if (this.personToCover.birthday != null && this.personToCover.birthday != "") {
                        let today = new Date();
                        if (this.personToCover.birthday.toString().length > 11) {
                            birthDate = new Date(this.personToCover.birthday);
                            age = today.getFullYear() - birthDate.getFullYear();
                            m = today.getMonth() - birthDate.getMonth();
                            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                                age--;
                            }
                            this.personToCover.age = age;
                            if (this.personToCover.age < 18) {
                                this.personToCoverMessageErrorAge = "La persona debe ser mayor de 18 años";
                            }
                            if (this.personToCover.age > 64) {
                                this.personToCoverMessageErrorAge = "La persona debe tener menos de 65 años";
                            }
                            if (this.personToCoverMessageErrorAge == "") {
                                this.personToCover.isBirthdayCorrect = true;
                            }
                        }
                        else {
                            let dateFormated = this.personToCover.birthday.split('/')[1] + "/" + this.personToCover.birthday.split('/')[0] + "/" + this.personToCover.birthday.split('/')[2];
                            birthDate = new Date(dateFormated);
                            age = today.getFullYear() - birthDate.getFullYear();
                            m = today.getMonth() - birthDate.getMonth();
                            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                                age--;
                            }
                            this.personToCover.age = age;
                            if (this.personToCover.age < 18) {
                                this.personToCoverMessageErrorAge = "La persona debe ser mayor de 18 años";
                            }
                            if (this.personToCover.age > 64) {
                                this.personToCoverMessageErrorAge = "La persona debe tener menos de 65 años";
                            }
                            if (this.personToCoverMessageErrorAge == "") {
                                this.personToCover.isBirthdayCorrect = true;
                            }
                        }
                    }
                    else {
                        this.personToCover.age = 0;
                    }
                }
            },
            payButtonDisableValidation: function () {
                if (this.firstName != null && this.firstName != "" &&
                    this.lastName != null && this.lastName != "" &&
                    this.areaCode != null && this.areaCode != "" &&
                    this.telephone != null && this.telephone != "" &&
                    this.email != null && this.email != "" &&
                    this.selectedIvaCondition != null &&
                    this.birthday != null &&
                    this.isBirthdayCorrect
                ) {
                    this.payButtonDisable = false;
                } else {
                    this.payButtonDisable = true;

                }
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultSafeHealthMaxGTMInfo';
                this.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
        },
        watch: {
            firstName(newVal) {
                this.payButtonDisableValidation();
            },
            lastName(newVal) {
                this.payButtonDisableValidation();
            },
            selectedIvaCondition(newVal, oldVal) {
                if (newVal == undefined) {
                    this.selectedIvaCondition = oldVal;
                }
                this.payButtonDisableValidation();
            },
            telephone(newVal) {
                this.payButtonDisableValidation();
            },
            areaCode(newVal) {
                this.payButtonDisableValidation();
            },
            'personToCover.birthday': function (newVal, oldVal) {
                if (newVal !== null && newVal !== "") {
                    this.ageCalculate(true);
                }
                if (this.personToCoverMessageErrorAge == "") {
                    //To-do no dejar que continue a la otra pantalla
                }
                this.validatePersonToCoverData();
            },
            'personToCover.firstName': function (newVal, oldVal) {
                this.validatePersonToCoverData();
            },
            'personToCover.lastName': function (newVal, oldVal) {
                this.validatePersonToCoverData();
            },
            birthday(newVal, oldVal) {
                let validBack = sessionStorage.getItem("pressBack") === 'true';
                if (newVal !== null && newVal !== "") {
                    this.ageCalculate();
                }
                if (this.messageErrorAge == "") {
                    this.payButtonDisableValidation();
                }
                if (validBack && newVal == null) {
                    // Solo actualiza this.birthday si newVal no es null
                    this.birthday = oldVal;
                }
            },
            email(newVal) {
                this.payButtonDisableValidation();
            },
            isAssuredTitular(newVal) {
                if (this.currentGroup == 1/*Individual*/ && newVal) {
                    this.totalStep = 2;
                } else if (this.currentGroup == 1 && !newVal) {
                    this.totalStep = 3;
                }
                if ((this.currentGroup == 2/*Matrimonial*/ || this.currentGroup == 3/*Familiar*/) && newVal) {
                    this.totalStep = 3;
                } else if ((this.currentGroup == 2/*Matrimonial*/ || this.currentGroup == 3/*Familiar*/) && !newVal) {
                    this.totalStep = 4;
                }
                sessionStorage.setItem("totalStep", this.totalStep.toString());
                sessionStorage.setItem("isAssuredTitular", newVal.toString());
            },
            isPersonExist(newVal) {
                this.payButtonDisableValidation();
            },
            totalStep(newVal) {
                this.isLastStep = (newVal - 1 == this.currentStep);
            },
        },
        mounted() {
            NF.UI.Page.block();
            this.updateByProductGoogleAnalytics();
            this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
            let planDescription = JSON.parse(sessionStorage.getItem("PlanDescription"));
            window.globalThis.dataLayer.push({ 'product': 'salud', 'event': 'cotizador-salud-plan', 'plan': planDescription });
            this.thereIsDiscount = sessionStorage.getItem("thereIsDiscount") === 'true';
            this.changeTitleAndIcon();
            let planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected"));
            this.currentGroup = parseInt(JSON.parse(sessionStorage.getItem("groupSelected")).id);
            let coversCapitalAndDescription = JSON.parse(sessionStorage.getItem("getHealthCoverCapitalAndDescription-Group" + (this.currentGroup)));
            this.coversDetail = coversCapitalAndDescription;
            let gridCovers = JSON.parse(sessionStorage.getItem("responseGetVWHealthGridCovers"));
            // Extraer listado de beneficios adicionales
            let peopleToCover = parseInt(sessionStorage.getItem("peopleToCover"));
            let groupId = peopleToCover === 1 ? 1 : 3;
            this.additionalCover = gridCovers.vwGridCovers.filter(item => item.gridCategoriesId === 2 && item.verticalGroupsId.includes(groupId)).map(item => {
                return {
                    coverDescription: item.coverDescription.trim()
                };
            });
            let planData = JSON.parse(sessionStorage.getItem("responseHealth321Quotation"));
            const formatDate = (dateString: string): string => {
                const date = new Date(dateString);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear().toString();
                return `${day}/${month}/${year}`;
            };
            // Asignar las fechas formateadas
            this.effectDate = formatDate(planData.effectDate);
            this.expirationDate = formatDate(planData.expirationDate);


            if (planDataSelected != null) {
                this.DataPlan = planDataSelected!;
                this.primerCuota = this.DataPlan.premioMensual;
                this.premiumWithoutDiscount = this.thereIsDiscount ? this.DataPlan.premiumWithoutDiscount : null;
                this.capital = this.DataPlan.capital;
            }
            if (this.currentGroup == 1/*Individual*/) {
                this.totalStep = 2;
            } else if (this.currentGroup == 2/*Matrimonial*/ || this.currentGroup == 3/*Familiar*/) {
                this.totalStep = 3;
            }
            this.getDocumentType();
            this.getIvaConditions();
            sessionStorage.setItem("totalStep", this.totalStep.toString());
            sessionStorage.setItem("currentStep", "2");
            let validBack = sessionStorage.getItem("pressBack") === 'true';
            if (validBack) {
                let policyOwner = sessionStorage.getItem("policyOwner");
                this.isAssuredTitular = sessionStorage.getItem("isAssuredTitular") === 'true';
                if (policyOwner != null) {
                    this.isPersonExist = true;
                    this.activeForm = true;
                    let policyOwnerJson = JSON.parse(policyOwner);
                    this.firstName = policyOwnerJson.firstName;
                    this.lastName = policyOwnerJson.lastName;
                    this.areaCode = policyOwnerJson.areaCode;
                    this.telephone = policyOwnerJson.telephone;
                    this.email = policyOwnerJson.email;
                    this.numDoc = policyOwnerJson.numDoc;
                    this.selectedIvaCondition = policyOwnerJson.selectedIvaCondition;
                    this.docTypeSelected = policyOwnerJson.docTypeSelected;
                    this.birthday = policyOwnerJson.birthday;
                    this.isPersonExist = policyOwnerJson.isPersonExist;
                    this.isBirthdayCorrect = policyOwnerJson.isBirthdayCorrect;
                    this.activeFormPersonNotExist = policyOwnerJson.activeFormPersonNotExist;
                    this.age = policyOwnerJson.age;
                    this.payButtonDisableValidation();
                }
            } else {
                this.isPersonExist = false;
                sessionStorage.removeItem("policyOwner");
                sessionStorage.setItem("isAssuredTitular", this.isAssuredTitular);
            }
            NF.UI.Page.unblock();
        }
    })
